import * as React from 'react';

export const IconRadio = ({ selected }: { selected: boolean }): JSX.Element => {
  return selected ? (
    <svg width="16" height="17" viewBox="0 0 16 17">
      <circle cx="8" cy="8.88867" r="8" fill="#2326DE" />
      <circle cx="8" cy="8.88867" r="3" fill="white" />
    </svg>
  ) : (
    <svg width="16" height="17" viewBox="0 0 16 17">
      <circle cx="8" cy="8.88867" r="7.5" fill="white" stroke="#D2DFEF" />
    </svg>
  );
};
